import HintCard from "./HintCard";
import { WIZARD_HINT_CONTENT } from "./hintContent";
import { useFieldFocus } from "./useFieldFocus";
import WizardStep from "./WizardStep";
import PreferencesSection from "../TemplateBuilder/components/PreferencesSection";

export default function TemplatePreferencesStep({
  control,
  onNext,
  onBack,
}) {
  const { focusedField, containerRef } = useFieldFocus();
  const hint = focusedField
    ? WIZARD_HINT_CONTENT[focusedField]
    : null;

  return (
    <WizardStep
      title="Template Preferences"
      description="These preferences apply to the entire note. They tell Scribenote's AI what style, tone, and formatting preferences to follow when generating a note from this template."
      onNext={onNext}
      onBack={onBack}
      nextLabel="Preview"
      dataTestId="wizard-step-template-preferences"
    >
      <div className="flex gap-lg" ref={containerRef}>
        <div
          className="flex-1 min-w-0 flex flex-col gap-md"
          data-hint-field="userPreferences"
        >
          <PreferencesSection control={control} />
        </div>
        <div className="hidden lg:block w-72 shrink-0">
          <div className="sticky top-20">
            <HintCard
              title={hint?.title}
              body={hint?.body}
              visible={!!hint}
              dataTestId="wizard-preferences-hint"
            />
          </div>
        </div>
      </div>
    </WizardStep>
  );
}
